var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "technical-notes" },
    [
      _vm._l(_vm.computedObj, function (item, index) {
        return _c("div", { key: index, staticClass: "item" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v("\n      " + _vm._s(item.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v("\n      " + _vm._s(item.text) + "\n    "),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.hasLimit
        ? [
            _c(
              "div",
              { staticClass: "item" },
              [
                _c("HighlightButton", {
                  attrs: {
                    "button-type": "rounded",
                    "button-style": "outline",
                    "button-size": "small",
                    title: "Show More",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showMore()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }